import React, { createContext, useContext, useEffect, useState } from "react";
export const THEME_KEY = "xa.site.theme";
export function readTheme() {
  try {
    const stored = localStorage.getItem(THEME_KEY);
    if (stored === "light" || stored === "dark") return stored;
    // Carry forward an explicitly selected legacy admin preference.
    if (localStorage.getItem("xa.admin.theme") === "light") return "light";
  } catch (_) { /* Preference storage is optional. */ }
  return "dark"; // Preserve Xavier's established appearance until the visitor chooses.
}
export function applyTheme(theme) {
  document.documentElement.dataset.theme = theme;
  document.documentElement.classList.toggle("dark", theme === "dark");
  document.documentElement.style.colorScheme = theme;
  document.querySelector('meta[name="theme-color"]')?.setAttribute("content", theme === "light" ? "#ffffff" : "#181a1d");
}
const ThemeContext = createContext({ theme: "dark", toggleTheme: () => {} });
export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(readTheme);
  useEffect(() => { applyTheme(theme); }, [theme]);
  useEffect(() => {
    const sync = (event) => {
      if (event.key === THEME_KEY && (event.newValue === "light" || event.newValue === "dark")) setTheme(event.newValue);
    };
    window.addEventListener("storage", sync);
    return () => window.removeEventListener("storage", sync);
  }, []);
  const toggleTheme = () => setTheme(previous => {
    const next = previous === "dark" ? "light" : "dark";
    try { localStorage.setItem(THEME_KEY, next); } catch (_) { /* In-memory choice still works. */ }
    return next;
  });
  return <ThemeContext.Provider value={{ theme, toggleTheme }}>{children}</ThemeContext.Provider>;
}
export const useTheme = () => useContext(ThemeContext);
